import PNLReportUseCase from "@domains/useCases/Reports/PnL/PNLReport";
import { DashboardSummarizedUseCase, FilterUseCase, PNLCommonUseCase, SearchUseCase, SortUseCase, SummarizedUseCase, } from "@domains/useCases/Reports/PnL/PNLCommonUsecase";
import PNLTransactionReportUseCase from "@domains/useCases/Reports/PnL/PNLTransactionReport";
import PNLEditTransactionReportUseCase from "@domains/useCases/Reports/PnL/PNLEditTransactionUseCase";
import DownloadPDFReport from "@domains/useCases/Reports/common/downloadReport/downloadPdfReport";
import DownloadExcelReport from "@domains/useCases/Reports/common/downloadReport/downloadExcelReport";
import EmailReport from "@domains/useCases/Reports/common/emailReport/emailReport";
import StreamUseCase from "@domains/useCases/StreamUsecase";
import DashboardSummaryUseCase from "@domains/useCases/Reports/dashboard/DashboardUsecase";
import HoldingTransactionsDetailsUseCase from "@domains/useCases/Reports/PnL/HoldingTransactionsDetails";
import PNLOriginalTransactionsUseCase from "@domains/useCases/Reports/PnL/PNLOriginalTransactions";
export default (repositories) => {
    return {
        pnlReport: new PNLReportUseCase(repositories.pnlMainScreenRepo),
        commonPNL: new PNLCommonUseCase(new SearchUseCase(), new FilterUseCase(), new SortUseCase(), new SummarizedUseCase(), new DashboardSummarizedUseCase()),
        pnlTransactionReport: new PNLTransactionReportUseCase(repositories.pnlTransactionRepo),
        pnlEditTransactionReport: new PNLEditTransactionReportUseCase(repositories.pnlTransactionRepo),
        downloadPDFReports: new DownloadPDFReport(repositories.downloadRepo),
        downloadExcelReports: new DownloadExcelReport(repositories.downloadRepo),
        sendEmailReports: new EmailReport(repositories.downloadRepo),
        quoteStream: new StreamUseCase(repositories.quoteStream),
        dashboardSummaryUseCase: new DashboardSummaryUseCase(repositories.dashboardRepo),
        holdingTxnUseCase: new HoldingTransactionsDetailsUseCase(repositories.pnlTransactionRepo),
        originalTxns: new PNLOriginalTransactionsUseCase(repositories.pnlTransactionRepo),
    };
};
